module.exports = __webpack_public_path__ + "img/mz_06.17a97747.png";